export default __webpack_public_path__ + "static/media/041-kangaroo.d5bb47b3.svg";